/**
 * @sunflowerlab
 * @author Ashish Kumar
 */
export class AppMessages {
  public static readonly passwordChange: string = 'You have successfully changed your secret.';
  public static readonly duplicateFilterName: string = 'A filter already exists in the system with this name. Please rename your filter and save again.';
  public static readonly noResultForCriteria: string = 'There is no data that matches your search criteria.';
  public static readonly userCreated: string = 'User created successfully.';
  public static readonly userUpdated: string = 'User authorization updated successfully.';
  public static readonly tagCategoryCreated: string = 'Tag category created successfully';
  public static readonly tagCategoryUpdated: string = 'Tag category updated successfully';
  public static readonly tagSubCategoryCreated: string = 'Tag sub category created successfully';
  public static readonly tagSubCategoryUpdated: string = 'Tag sub category updated successfully';
  public static readonly tagCreated: string = 'Tag created successfully';
  public static readonly tagUpdated: string = 'Tag updated successfully';
  public static readonly dailyExpenseTypeCreated: string = 'Daily Expense Type created successfully';
  public static readonly dailyExpenseTypeUpdated: string = 'Daily Expense Type updated successfully';
  public static readonly monthlyExpenseTypeCreated: string = 'Monthly Expense Type created successfully';
  public static readonly monthlyExpenseTypeUpdated: string = 'Monthly Expense Type updated successfully';
  public static readonly workExceptionTypeCreated: string = 'Work Exception Type created successfully';
  public static readonly workExceptionTypeUpdated: string = 'Work Exception Type updated successfully';
  public static readonly employeeTypeCreated: string = 'Employee Type created successfully';
  public static readonly employeeTypeUpdated: string = 'Employee Type updated successfully';
  public static readonly skillSetCreated: string = 'Skill Set created successfully';
  public static readonly skillSetUpdated: string = 'Skill Set updated successfully';
}
